/* TSO builder — colour step: two target chips over one visible palette.

   The hidden #primaryColorMain / #secondaryColorMain selects remain THE state
   holders; the swatch driver in main-pri-sec-color-selection.liquid still owns
   tile <-> select syncing. This file adds only the layer above it:

     - which side ("target") the palette is currently painting
     - the category tab bar inside each side
     - the swap button, which is hidden whenever the two picks cannot legally
       trade sides (Polished is secondary-only on most products)
     - the chip readouts, refreshed off the selects' own change event

   Two-tone is a COMBINATION decision, so both colours stay on screen at all
   times. Never turn this into a step-through. */
(function () {
  'use strict';
  if (window.__cpbColorTabs) return;
  window.__cpbColorTabs = true;

  var ARMED = 'primary';

  function field(side) {
    return document.querySelector('.cpb-field[data-cpb-side="' + side + '"]');
  }
  function selectOf(side) {
    var f = field(side);
    return f ? f.querySelector('select[data-cpb-driven]') : null;
  }
  function labels(sel) {
    var out = {};
    if (!sel) return out;
    for (var i = 0; i < sel.options.length; i++) {
      out[sel.options[i].getAttribute('data-value') || sel.options[i].value] = i;
    }
    return out;
  }
  function currentLabel(sel) {
    var o = sel && sel.options[sel.selectedIndex];
    return o ? (o.getAttribute('data-value') || o.value) : '';
  }

  /* ---- inline powder catalog (the Custom tab) --------------------------
     This REPLACES the powder-search modal for the main builder. A modal
     throws away the canvas and both chips, which is exactly what a shopper
     needs to see while picking a custom colour. Same cache, same pick(), so
     pricing / SKU / fee / lead / GID / uuid are byte-identical either way. */
  var PAGE_ROWS = 5;
  function pageSize() {
    return PAGE_ROWS * (window.matchMedia('(min-width: 768px)').matches ? 5 : 3);
  }
  var catState = {}; /* per side: { q, shown } */

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }
  function basePrice(sel) {
    var o = sel && sel.options[0];
    return o ? parseFloat(o.getAttribute('data-baseprice') || '0') : 0;
  }

  function catalogTile(c, side, base, isOn, secOff) {
    /* Secondary is discounted by the block's data-secpriceoff (50 = half
       price) and pick() bakes that into data-secondarychange, so the tile
       MUST apply it too or it advertises double what it charges — the same
       defect the match tiles carried. The Liquid tiles already dampen
       (cpb-color-swatch.liquid); this JS renderer was the last one left. */
    var pct = side === 'secondary'
      ? (c.sec || 0) * (secOff == null ? 100 : secOff) / 100
      : (c.pri || 0);
    var amount = Math.round(pct * base / 100);
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cpb-cat' + (isOn ? ' is-selected' : '');
    b.setAttribute('data-cpb-label', c.label);
    b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', isOn ? 'true' : 'false');
    var face = c.image
      ? '<span class="cpb-swatch__tile"><img src="' + c.image + '" alt="" loading="lazy" onerror="this.remove()"></span>'
      : '<span class="cpb-swatch__tile" style="background:' + (c.hex || '#444') + '"></span>';
    b.innerHTML = face
      + '<span class="cpb-swatch__name"></span>'
      + '<span class="cpb-swatch__price">' + (amount > 0 ? '+' + money(amount) : 'No charge') + '</span>'
      + (c.lead ? '<span class="cpb-swatch__lead">+' + c.lead + ' days</span>' : '');
    b.querySelector('.cpb-swatch__name').textContent = c.label;
    return b;
  }

  function renderCatalog(f) {
    var side = f.getAttribute('data-cpb-side');
    var panel = f.querySelector('[data-cpb-custom]');
    var tab = f.querySelector('.cpb-tab[data-cpb-all]');
    var sel = selectOf(side);
    if (!panel || !tab || !sel || !window.TSOPowder) return;

    var st = catState[side] || (catState[side] = { q: '', shown: 0 });
    var drop = (tab.getAttribute('data-cpb-exclude') || '').split('|').filter(Boolean);

    panel.hidden = false;
    if (!panel.firstChild) {
      panel.innerHTML =
        '<label class="cpb-cat__search">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false">' +
        '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
        '<input type="search" data-cpb-cat-search placeholder="Search powder colors">' +
        '</label><p class="cpb-cat__note" data-cpb-cat-note></p>' +
        '<div class="cpb-cat__grid" role="radiogroup" data-cpb-cat-grid></div>';
    }

    window.TSOPowder.catalog().then(function (colors) {
      var pool = window.TSOPowder.sortColors(
        (colors || []).filter(function (c) { return drop.indexOf(c.label) === -1; })
      );
      var q = st.q.toLowerCase();
      var hits = q ? pool.filter(function (c) { return c.label.toLowerCase().indexOf(q) > -1; }) : pool;
      var limit = Math.min(st.shown || pageSize(), hits.length);
      var base = basePrice(sel);
      var secOff = parseFloat(sel.getAttribute('data-secpriceoff') || '100');
      var cur = currentLabel(sel);

      var grid = panel.querySelector('[data-cpb-cat-grid]');
      grid.innerHTML = '';
      for (var i = 0; i < limit; i++) grid.appendChild(catalogTile(hits[i], side, base, hits[i].label === cur, secOff));

      var rest = hits.length - limit;
      var old = panel.querySelector('.cpb-cat__more');
      if (old) old.parentNode.removeChild(old);
      if (rest > 0) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'cpb-cat__more';
        more.setAttribute('data-cpb-cat-more', '');
        more.innerHTML = 'Show ' + Math.min(rest, pageSize()) + ' more<em>' + rest.toLocaleString() + ' left</em>';
        panel.appendChild(more);
      }
      panel.querySelector('[data-cpb-cat-note]').textContent =
        'Showing ' + limit + ' of ' + hits.length.toLocaleString()
        + (drop.length ? ' · ' + drop.join(', ') + ' is not available on this side' : '');
    });
  }

  /* ---- tabs ------------------------------------------------------------ */
  /* The selected tile is pinned visible even when it belongs to another tab.
     Losing sight of your own pick reads as "the builder lost my colour". */
  function showTab(f, tabIndex) {
    /* A tab shows ITS OWN colours and nothing else. An earlier build kept the
       current pick visible across tabs; Ben killed it (2026-08-22) — a tile
       from another category reads as clutter, not as reassurance. The chip
       above already shows what is selected. */
    var tiles = f.querySelectorAll('.cpb-swatch');
    for (var i = 0; i < tiles.length; i++) {
      var t = tiles[i];
      if (t.getAttribute('data-cpb-tab') === String(tabIndex)) t.removeAttribute('hidden');
      else t.setAttribute('hidden', '');
    }
    var tabs = f.querySelectorAll('.cpb-tab');
    var armed = null;
    for (var j = 0; j < tabs.length; j++) {
      var on = tabs[j].getAttribute('data-cpb-tab') === String(tabIndex);
      tabs[j].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[j].tabIndex = on ? 0 : -1;
      if (on) armed = tabs[j];
    }

    var panel = f.querySelector('[data-cpb-custom]');
    if (armed && armed.hasAttribute('data-cpb-all')) {
      var side = f.getAttribute('data-cpb-side');
      if (catState[side]) catState[side].shown = 0;
      renderCatalog(f);
    } else if (panel) {
      panel.hidden = true;
    }

    /* the "your paint" / "your trim" tiles belong to the Color Match tab only */
    var match = f.querySelector('[data-cpb-match]');
    if (match) {
      var on = !!(armed && armed.hasAttribute('data-cpb-match-tab'));
      match.hidden = !on;
      if (on) matchEmptyState(f);
    }
  }

  /* A tab is worth opening on if it will paint something: the catalogue tab
     always will, a Colour Match tab only once its tiles exist, any other tab
     if it owns at least one tile. */
  function tabHasContent(f, tab) {
    if (!tab) return false;
    if (tab.hasAttribute('data-cpb-all')) return true;
    if (tab.hasAttribute('data-cpb-match-tab')) {
      var m = f.querySelector('[data-cpb-match]');
      return !!(m && m.querySelector('.tso-match-tile'));
    }
    var i = tab.getAttribute('data-cpb-tab');
    return !!f.querySelector('.cpb-swatch[data-cpb-tab="' + i + '"]');
  }

  /* Clicking Colour Match without a saved truck must say why it is empty and
     offer the way out. /#select-vehicle is wired site-wide by tso-vehicle.js. */
  function matchEmptyState(f) {
    var m = f.querySelector('[data-cpb-match]');
    if (!m || m.querySelector('.tso-match-tile') || m.querySelector('.cpb-match__empty')) return;
    var d = document.createElement('div');
    d.className = 'cpb-match__empty';
    d.innerHTML = '<p>Tell us your truck and we will match its factory paint.</p>' +
                  '<a class="cpb-match__cta" href="/#select-vehicle">Pick your truck</a>';
    m.appendChild(d);
  }

  /* ---- chips ----------------------------------------------------------- */
  function paintChip(side) {
    var chip = document.querySelector('[data-cpb-chip="' + side + '"]');
    var sel = selectOf(side);
    var f = field(side);
    if (!chip || !sel || !f) return;

    var opt = sel.options[sel.selectedIndex];
    var name = chip.querySelector('.cpb-chip__name');
    var sw = chip.querySelector('.cpb-chip__sw');
    if (name) name.textContent = currentLabel(sel);

    /* The price element inside the chip is the builder's own
       .primaryPriceChange / .secondaryPriceChange span
       (custom-build-product-script-new.js:1816). It stays that script's to
       write — do not set it here or the two writers fight. */
    if (!sw) return;

    /* Find the face for the CURRENT colour. A catalogue pick has no
       .cpb-swatch of its own, so fall back to its .cpb-cat tile by label. */
    var label = currentLabel(sel);
    var src = null;
    var tile = f.querySelector('.cpb-swatch[data-cpb-index="' + sel.selectedIndex + '"] .cpb-swatch__tile img');
    if (tile) src = tile.getAttribute('src');
    if (!src) {
      var cats = f.querySelectorAll('.cpb-cat');
      for (var c = 0; c < cats.length && !src; c++) {
        if (cats[c].getAttribute('data-cpb-label') === label) {
          var ci = cats[c].querySelector('img');
          if (ci) src = ci.getAttribute('src');
        }
      }
    }

    /* Set BOTH layers every time, never the `background` shorthand.
       Writing the shorthand for a colour with no image left a background
       COLOUR behind, and the next colour only replaced the background IMAGE
       — the swatch PNGs have transparent chamfered corners, so the previous
       custom colour bled through them and the chip showed two colours at
       once (Ben 2026-08-22: chartreuse behind Illusion Purple). */
    if (src) {
      sw.style.backgroundImage = 'url(' + src + ')';
      sw.style.backgroundColor = '';
    } else {
      sw.style.backgroundImage = 'none';
      sw.style.backgroundColor = (opt && opt.getAttribute('data-colorcode')) || '';
    }
  }

  function arm(side) {
    ARMED = side;
    ['primary', 'secondary'].forEach(function (s) {
      var f = field(s);
      var chip = document.querySelector('[data-cpb-chip="' + s + '"]');
      if (f) f.classList.toggle('is-armed', s === side);
      if (chip) chip.setAttribute('aria-pressed', s === side ? 'true' : 'false');
    });
  }

  /* ---- swap ------------------------------------------------------------ */
  /* Offered when both picks are legal on the opposite side. "Legal" means CAN
     THIS SIDE REACH THE COLOUR, not does the option already exist: a catalogue
     powder is only injected into a select once someone picks it there, but a
     side whose Custom tab covers the whole catalogue can still take it. Asking
     the narrower question made swap vanish for good the moment either side
     held a custom colour (Ben 2026-08-22). Polished stays untradeable wherever
     the primary's Custom tab excludes it — the whole reason the
     custom-no-polish tab entry exists. */
  function catalogTab(side) {
    var f = field(side);
    return f ? f.querySelector('.cpb-tab[data-cpb-all]') : null;
  }
  function canAccept(side, label) {
    var sel = selectOf(side);
    if (!sel || !label) return false;
    if (labels(sel)[label] !== undefined) return true;
    var tab = catalogTab(side);
    if (!tab) return false;
    var drop = (tab.getAttribute('data-cpb-exclude') || '').split('|').filter(Boolean);
    return drop.indexOf(label) === -1;
  }

  function syncSwap() {
    var btn = document.querySelector('[data-cpb-swap]');
    if (!btn) return;
    var p = selectOf('primary');
    var s = selectOf('secondary');
    if (!p || !s) { btn.hidden = true; return; }
    btn.hidden = !(canAccept('secondary', currentLabel(p)) && canAccept('primary', currentLabel(s)));
  }

  /* Put `label` on `side`, injecting it from the catalogue when the option does
     not exist there yet. TSOPowder.pick() injects, selects, and fires the
     change event every downstream consumer already listens for. */
  function setSide(side, label) {
    var sel = selectOf(side);
    if (!sel) return;
    var i = labels(sel)[label];
    if (i !== undefined) {
      sel.selectedIndex = i;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (!window.TSOPowder) return;
    window.TSOPowder.catalog().then(function (colors) {
      for (var n = 0; n < colors.length; n++) {
        if (colors[n].label === label) { window.TSOPowder.pick(sel, colors[n], true); return; }
      }
    });
  }

  function doSwap() {
    var p = selectOf('primary');
    var s = selectOf('secondary');
    if (!p || !s) return;
    var pLabel = currentLabel(p);   /* read BOTH before mutating either */
    var sLabel = currentLabel(s);
    if (!canAccept('secondary', pLabel) || !canAccept('primary', sLabel)) return;
    setSide('primary', sLabel);
    setSide('secondary', pLabel);
  }

  /* ---- variant reprice -------------------------------------------------- */
  /* Every tile price is pct-of-BASE, and "base" means the variant the shopper
     picked on the earlier steps — not variants[0], which is all Liquid knows
     at render time. The builder rewrites every option's data-baseprice on a
     variant match and then fires cpb:variant:changed
     (custom-build-product-script-new.js), so basePrice(sel) is already the
     new truth when this runs. Static tiles carry their own data-cpb-pct for
     exactly this repaint; an open catalog grid re-renders through the same
     path a tab click uses. Match tiles reprice themselves — powder-search.js
     listens for the same event. */
  function repriceTiles() {
    ['primary', 'secondary'].forEach(function (s) {
      var f = field(s);
      var sel = selectOf(s);
      if (!f || !sel) return;
      var base = basePrice(sel);
      f.querySelectorAll('.cpb-swatch[data-cpb-pct]').forEach(function (t) {
        var out = t.querySelector('[data-cpb-swatch-price]');
        if (!out) return;
        var amount = Math.round(parseFloat(t.getAttribute('data-cpb-pct') || '0') * base / 100);
        out.textContent = amount > 0 ? '+' + money(amount) : 'No charge';
      });
      var panel = f.querySelector('[data-cpb-custom]');
      if (panel && !panel.hidden && panel.firstChild) renderCatalog(f);
    });
  }

  /* ---- wiring ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* inline catalog: pick a powder. noStripTile — the catalog tile the
       shopper just clicked IS the selection; powder-search's injected strip
       swatch would read as a second selected thing. */
    var cat = e.target.closest('.cpb-cat');
    if (cat) {
      e.preventDefault();
      var cf = cat.closest('.cpb-field');
      var csel = cf && cf.querySelector('select[data-cpb-driven]');
      if (!csel || !window.TSOPowder) return;
      var wanted = cat.getAttribute('data-cpb-label');
      window.TSOPowder.catalog().then(function (colors) {
        for (var i = 0; i < colors.length; i++) {
          if (colors[i].label === wanted) { window.TSOPowder.pick(csel, colors[i], true); return; }
        }
      });
      return;
    }
    if (e.target.closest('[data-cpb-cat-more]')) {
      e.preventDefault();
      var mf = e.target.closest('.cpb-field');
      var ms = mf && mf.getAttribute('data-cpb-side');
      if (!ms) return;
      catState[ms].shown = (catState[ms].shown || pageSize()) + pageSize();
      renderCatalog(mf);
      return;
    }

    var el = e.target.closest('.cpb-tab, [data-cpb-chip], [data-cpb-swap]');
    if (!el) return;
    e.preventDefault();

    if (el.classList.contains('cpb-tab')) {
      var f = el.closest('.cpb-field');
      if (f) showTab(f, el.getAttribute('data-cpb-tab'));
      return;
    }
    if (el.hasAttribute('data-cpb-swap')) {
      var icon = el.querySelector('svg');
      if (icon) {
        el.classList.add('is-spun');
        setTimeout(function () { el.classList.remove('is-spun'); }, 440);
      }
      doSwap();
      return;
    }
    arm(el.getAttribute('data-cpb-chip'));
  });

  /* keyboard: left/right walk the tab bar, matching the ARIA tabs pattern */
  document.addEventListener('keydown', function (e) {
    var t = e.target.closest ? e.target.closest('.cpb-tab') : null;
    if (!t) return;
    if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) === -1) return;
    var bar = t.parentNode;
    var tabs = Array.prototype.slice.call(bar.querySelectorAll('.cpb-tab'));
    var i = tabs.indexOf(t);
    var n = e.key === 'Home' ? 0
          : e.key === 'End' ? tabs.length - 1
          : e.key === 'ArrowRight' ? (i + 1) % tabs.length
          : (i - 1 + tabs.length) % tabs.length;
    e.preventDefault();
    tabs[n].click();
    tabs[n].focus();
  });

  /* the selects are the source of truth — repaint whenever they move, which
     also covers powder-search injecting a catalog colour and the builder's
     own restore-from-saved-build pass */
  var searchTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-cpb-cat-search]')) return;
    var f = e.target.closest('.cpb-field');
    var side = f && f.getAttribute('data-cpb-side');
    if (!side) return;
    catState[side].q = e.target.value;
    catState[side].shown = 0;          /* a new search starts at the first rows */
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () { renderCatalog(f); }, 120);
  });

  document.addEventListener('cpb:variant:changed', repriceTiles);

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches) return;
    if (!e.target.matches('#primaryColorMain, #secondaryColorMain')) return;
    var side = e.target.id === 'primaryColorMain' ? 'primary' : 'secondary';
    paintChip(side);
    syncSwap();
    /* keep the catalog grid's ring in step — powder-search injects the option
       and fires this event, so this is also how an inline pick gets marked */
    var f = field(side);
    var label = currentLabel(e.target);
    if (f) {
      f.querySelectorAll('.cpb-cat').forEach(function (t) {
        var on = t.getAttribute('data-cpb-label') === label;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
  });

  /* Tiles ship with data-cpb-handle, not an index: one colour can appear in
     several tabs while the <select> holds it once, so a render counter would
     be wrong. Stamp each tile with its option's real index here — the shared
     swatch driver reads data-cpb-index and knows nothing about tabs. */
  function stampIndices(f) {
    var sel = f.querySelector('select[data-cpb-driven]');
    if (!sel) return;
    var byHandle = {}, byLabel = {};
    for (var i = 0; i < sel.options.length; i++) {
      var h = sel.options[i].getAttribute('data-handle');
      var l = sel.options[i].getAttribute('data-value') || sel.options[i].value;
      if (h && byHandle[h] === undefined) byHandle[h] = i;
      if (l && byLabel[l] === undefined) byLabel[l] = i;
    }
    f.querySelectorAll('.cpb-swatch[data-cpb-handle]').forEach(function (t) {
      var i = byHandle[t.getAttribute('data-cpb-handle')];
      /* Label fallback. Handles come from option.system.handle; if that ever
         renders blank again, matching on the visible name still leaves every
         tile clickable instead of silently deadening the whole palette. */
      if (i === undefined) {
        var nameEl = t.querySelector('.cpb-swatch__name');
        if (nameEl) i = byLabel[nameEl.textContent.trim()];
      }
      if (i !== undefined) t.setAttribute('data-cpb-index', String(i));
      else t.setAttribute('hidden', ''); /* no option to select — never show it */
    });
    /* The shared driver's mark() may already have run against the unstamped
       tiles, so re-apply the selected state here rather than dispatching a
       change, which would re-fire pricing and the Custom Colour hook. Both
       copies of a colour that sits in two tabs light up, which is correct. */
    var cur = String(sel.selectedIndex);
    f.querySelectorAll('.cpb-swatch[data-cpb-index]').forEach(function (t) {
      var on = t.getAttribute('data-cpb-index') === cur;
      t.classList.toggle('is-selected', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
  }

  function init() {
    if (!field('primary') && !field('secondary')) return;
    ['primary', 'secondary'].forEach(function (s) {
      var f = field(s);
      if (!f) return;
      stampIndices(f);
      /* Colour Match is the first tab on most products, but it renders nothing
         until a truck is saved — powder-search.js fills it from the vehicle
         cookie. Landing there anonymously showed an EMPTY palette on first
         paint. Open on the first tab that actually has something in it; the
         Colour Match tab stays clickable and explains itself when picked. */
      var tabs = f.querySelectorAll('.cpb-tab');
      var open = null;
      for (var t = 0; t < tabs.length && !open; t++) {
        if (tabHasContent(f, tabs[t])) open = tabs[t];
      }
      if (!open) open = tabs[0];
      if (open) showTab(f, open.getAttribute('data-cpb-tab'));
      paintChip(s);
    });
    arm('primary');
    syncSwap();
    /* A saved-build restore can move the variant BEFORE this file's listener
       existed (script order); reprice from the DOM's current data-baseprice
       so first paint is right either way. No-op on a fresh anonymous load —
       options[0] still carries the same variants[0] price the tiles were
       rendered from. */
    repriceTiles();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
